import { title } from 'process';
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Observable, Subscription } from 'rxjs';
import { Survey } from './shared/model-service';

@Component({
  selector: 'app-survey-display',
  templateUrl: './survey-display.component.html',
  styleUrls: ['./survey-display.component.css']
})
export class SurveyDisplayComponent implements OnInit {

  // Création du Survey avec questions imbriquées
  surveyToKeep: Survey;
  // Survey de base avec toutes les questions à plat
  SurveyBase: any;
  // Reception du Survey en paramètres
  eventsSubs: Subscription;
  @Input() events: Observable<any>;

  @Output() saveEventEmitter: EventEmitter<any> = new EventEmitter();

  survey: Survey;

  constructor() {
  }

  ngOnInit(): void {
    this.eventsSubs = this.events.subscribe((result:any)=> {​​​​​​​​
      this.SurveyBase = result;
      this.treatSUrvey();
    }​​​​​​​​);
  }

  getQuestions() {
    return this.surveyToKeep?.questions;
  }

  // Création du questionnaire de réponse reçu en Input
  treatSUrvey(): void {
    this.surveyToKeep = {
      id: this.SurveyBase.id,
      title: this.SurveyBase.title,
      questions: [],
      finish: false,
      popups: this.SurveyBase.popups
    }

    // Création du questionnaire imbriqué en fonction des destination id links.
    this.SurveyBase.questions.forEach(question => {
      question.options.forEach(option => {
        option.links.forEach(link => {
          if (link.questionDestinationId != null) {
            let questionToRemove = this.SurveyBase.questions.find(x => x.id == link.questionDestinationId);
            this.surveyToKeep.questions.push(questionToRemove);
          }
        });
      });
    });

    this.surveyToKeep.questions = this.SurveyBase.questions.filter(item => this.surveyToKeep.questions.indexOf(item) < 0);
  }

  save(survey){
    this.saveEventEmitter.emit(survey);
  }
}
